import React, { useState, useEffect } from 'react';
import { apiService } from '../services/api';

interface Device {
  device_id: string;
  name: string;
  os: string;
  status: string;
  compliance_status: string;
  agent_id?: string;
  last_seen?: string;
}

const LinuxManagement: React.FC = () => {
  const [devices, setDevices] = useState<Device[]>([]);
  const [selectedDevices, setSelectedDevices] = useState<string[]>([]);

  useEffect(() => {
    loadDevices();
  }, []);

  const loadDevices = async () => {
    try {
      const response = await apiService.getDevices();
      const linuxDevices = response.filter((device: Device) => {
        const os = device.os?.toLowerCase() || '';
        return os.includes('linux') || os.includes('ubuntu') || os.includes('debian') ||
               os.includes('centos') || os.includes('rhel') || os.includes('fedora');
      });
      setDevices(linuxDevices);
    } catch (err) {
      console.error('Error loading devices:', err);
    }
  };

  const toggleDeviceSelection = (deviceId: string) => {
    setSelectedDevices(prev =>
      prev.includes(deviceId)
        ? prev.filter(id => id !== deviceId)
        : [...prev, deviceId]
    );
  };

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ marginBottom: '24px' }}>
        <h1 style={{ fontSize: '28px', fontWeight: '700', marginBottom: '8px', color: '#1f2937' }}>
          Linux Management
        </h1>
        <p style={{ color: '#6b7280', fontSize: '16px' }}>
          Manage Ubuntu, CentOS, Debian, RHEL, and other Linux distributions
        </p>
      </div>

      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
          <h2 className="card-title">Devices ({devices.length})</h2>
          <button className="action-btn">+ Enroll Device</button>
        </div>

        {devices.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '48px', color: '#6b7280' }}>
            <svg width="64" height="64" fill="#fcc624" viewBox="0 0 24 24" style={{ margin: '0 auto 16px', opacity: 0.5 }}>
              <path d="M12.504 0c-.155 0-.315.008-.48.021-4.226.333-3.105 4.807-3.17 6.298-.076 1.092-.3 1.953-1.05 3.02-.885 1.051-2.127 2.75-2.716 4.521-.278.832-.41 1.684-.287 2.489a.424.424 0 00-.11.135c-.26.265-.45.46-.636.78-.208.356-.352.782-.437 1.245-.061.331-.096.777-.096 1.312 0 1.623.547 2.74 1.092 3.498.545.758 1.276 1.312 2.286 1.312.356 0 .69-.073 1.004-.2.356-.145.69-.382 1.004-.69.356-.356.69-.802 1.004-1.337.356-.602.69-1.312 1.004-2.123.2-.535.356-1.092.48-1.684.145-.69.247-1.4.315-2.123.08-.823.08-1.684 0-2.545-.08-.823-.17-1.623-.315-2.312-.145-.69-.28-1.312-.48-1.847-.356-1.004-.69-1.847-1.004-2.545-.356-.758-.69-1.312-1.004-1.684-.2-.207-.356-.356-.48-.445a.424.424 0 00-.135-.11c-.356-.186-.69-.287-1.004-.287zm.992 4.176c.58 0 1.051.471 1.051 1.051s-.471 1.051-1.051 1.051-1.051-.471-1.051-1.051.471-1.051 1.051-1.051z"/>
            </svg>
            <p style={{ fontSize: '18px', fontWeight: '500', marginBottom: '8px' }}>No Linux devices enrolled</p>
            <p>Enroll Linux devices to start managing them</p>
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table className="device-table">
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      checked={selectedDevices.length === devices.length && devices.length > 0}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedDevices(devices.map(d => d.device_id));
                        } else {
                          setSelectedDevices([]);
                        }
                      }}
                    />
                  </th>
                  <th>Device Name</th>
                  <th>Distribution</th>
                  <th>Status</th>
                  <th>Compliance</th>
                  <th>Last Seen</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {devices.map((device) => (
                  <tr key={device.device_id}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedDevices.includes(device.device_id)}
                        onChange={() => toggleDeviceSelection(device.device_id)}
                      />
                    </td>
                    <td style={{ fontWeight: '500', color: '#1f2937' }}>{device.name}</td>
                    <td style={{ color: '#4b5563' }}>{device.os}</td>
                    <td>
                      <span className={`status-badge ${device.status === 'online' ? 'compliant' : 'warning'}`}>
                        {device.status}
                      </span>
                    </td>
                    <td>
                      <span className={`status-badge ${device.compliance_status === 'compliant' ? 'compliant' : 'error'}`}>
                        {device.compliance_status}
                      </span>
                    </td>
                    <td style={{ color: '#6b7280' }}>
                      {device.last_seen ? new Date(device.last_seen).toLocaleString() : 'Never'}
                    </td>
                    <td>
                      <button className="quick-action-btn" style={{ fontSize: '12px', padding: '4px 8px' }}>
                        Manage
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default LinuxManagement;
